import type { ReactNode } from 'react';

export function SheetHost(props: { children?: ReactNode }) {
  return props.children ? <div className="mira-sheet-host">{props.children}</div> : null;
}
